/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkspaceWaitingForRetrieval
 */
export interface WorkspaceWaitingForRetrieval {
    /**
     * 
     * @type {string}
     * @memberof WorkspaceWaitingForRetrieval
     */
    workspaceNamespace: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceWaitingForRetrieval
     */
    workspaceName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceWaitingForRetrieval
     */
    creator?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceWaitingForRetrieval
     */
    lastModifiedTime?: number;
}

/**
 * Check if a given object implements the WorkspaceWaitingForRetrieval interface.
 */
export function instanceOfWorkspaceWaitingForRetrieval(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "workspaceNamespace" in value;
    isInstance = isInstance && "workspaceName" in value;

    return isInstance;
}

export function WorkspaceWaitingForRetrievalFromJSON(json: any): WorkspaceWaitingForRetrieval {
    return WorkspaceWaitingForRetrievalFromJSONTyped(json, false);
}

export function WorkspaceWaitingForRetrievalFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceWaitingForRetrieval {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'workspaceNamespace': json['workspaceNamespace'],
        'workspaceName': json['workspaceName'],
        'creator': !exists(json, 'creator') ? undefined : json['creator'],
        'lastModifiedTime': !exists(json, 'lastModifiedTime') ? undefined : json['lastModifiedTime'],
    };
}

export function WorkspaceWaitingForRetrievalToJSON(value?: WorkspaceWaitingForRetrieval | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'workspaceNamespace': value.workspaceNamespace,
        'workspaceName': value.workspaceName,
        'creator': value.creator,
        'lastModifiedTime': value.lastModifiedTime,
    };
}

